<template>
  <div>
    <div v-if="openEditCostElement">
      <edit-single-cost-element
      :route="route"
        @cancel="openEditCostElement = false"
      ></edit-single-cost-element>
    </div>
    <div v-else>
      <div v-if="openCostElement">
        <cost-element
          @cancel="openCostElement = false"
          :selectedRoute="selectedRoute"
        ></cost-element>
      </div>
      <selected-route-table
        v-else
        @editRouteSetting="editRoute"
        @setCostElement="openCostElement = true"
        @openEditCostElement="openEditCostElement = true"
        @selectedRoute="setSelectedRoute"
      >
      </selected-route-table>
    </div>
  </div>
</template>

<script>
import CostElement from "./CostElement.vue";
import EditSingleCostElement from "./EditSingleCostElement.vue";
import SelectedRouteTable from "./SelectedRouteTable.vue";

export default {
  components: {
    CostElement,
    EditSingleCostElement,
    SelectedRouteTable,
  },
  data() {
    return {
      selectedRoute: [],
      route: null,
      openCostElement: false,
      openEditCostElement: false,
    };
  },
  methods: {
    setSelectedRoute(selectedRoute) {
      this.selectedRoute = selectedRoute;
    },
    editRoute(e) {
      this.route = e;
    },
  },
  mounted() {
    this.setSelectedRoute;
  },
};
</script>

<style scoped>
.estimateBox {
  border: 1px solid #dae8f6;
  border-radius: 2px;
  width: 207px;
  height: 44px;
  font-size: 24px;
  font-weight: 600;
  margin-top: -10px;
  padding: 5.5px 10px 5.5px 80px;
}
</style>